import {
    postApiLogin
} from "./api/login"

class LoginService{
    async doLogin(params){
        try {
            const loginResult = postApiLogin(params)
            return loginResult
        } catch(error) {
            return error
        }
    }
}

export default new LoginService()